export const boxesConstants = {
  GET_BOXES_TABLE_DATA: 'boxes/GET_BOXES_TABLE_DATA',
  SET_BOXES_TABLE_DATA: 'boxes/SET_BOXES_TABLE_DATA',
  CLEAR_BOXES: 'boxes/CLEAR_BOXES',
  UPDATE_BOXES_VIA_SOCKET: 'boxes/UPDATE_BOXES_VIA_SOCKET',
};
